var _path, _circle, _path2, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFrame = function SvgFrame(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#505259",
    d: "M2.5 6.25a.75.75 0 0 1 .75-.75h11.5a.75.75 0 0 1 0 1.5H3.25a.75.75 0 0 1-.75-.75"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.25,
    cy: 6.25,
    r: 1.5,
    fill: "#fff",
    stroke: "#505259",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#505259",
    d: "M2.5 11.75a.75.75 0 0 1 .75-.75h11.5a.75.75 0 0 1 0 1.5H3.25a.75.75 0 0 1-.75-.75"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.75,
    cy: 11.75,
    r: 1.5,
    fill: "#fff",
    stroke: "#505259",
    strokeWidth: 1.5
  })));
};
export default SvgFrame;